import Filter from '../plugins/Filter';
import URL from '../plugins/URL';
import Get from '../plugins/Get';

$(function () {

    if ($('#stock').length === 0)
        return;

    const filter = (new Filter('#stock'))
        .onChange([], function () {
            $.ajax({
                type: 'POST',
                url: `/ajax/filter/count-${URL.route[1]}/`,
                data: filter.data,
                beforeSend: () => {
                },
                complete: () => {
                },
                success: count => {
                    $('.title__counter').text(count);
                }
            });
        });

    filter.$.submit(function (e) {
        let query, i, key, data, url;
        e.preventDefault();
        url = '/buy/cars/';

        data = filter.data;
        for (key in data) {
            if (data.hasOwnProperty(key)) {
                if (typeof data[key] === 'string') {
                    if (data[key] === '')
                        delete data[key];
                } else {

                    for (i = 0; i < data[key].length; i++) {
                        if (data[key][i] === '')
                            delete data[key][i];
                    }
                    if (data[key].length === 0 || (data[key].length === 1 && typeof data[key][0] === 'undefined'))
                        delete data[key];
                }
            }
        }

        if (data.model && data.model.length === 1) {
            url += filter.$.find('[name="model[]"]').find(`[value="${data.model[0]}"]`).data('url') + '/';
            delete data.model;
        }

        query = Get.serialize(data);
        url += query === '' ? '' : '?' + query;
        window.location.href = url;
    });

    $('[data-sort]').click(function () {
        filter.$.submit();
    });

    $('.sort .switcher').click(function () {
        filter.$.submit();
    });

});